<template>
  <div
    class="px-4 pt-2 pb-3 border-t dark:border-surface-700 flex gap-4 items-center justify-end"
  >
    <AppButton
      outlined
      :variant="isCurrentRouteDisplayed ? undefined : 'secondary'"
      class="gap-2"
      @click="toggleCurrentRoute()"
    >
      <i
        class="pi text-lg"
        :class="isCurrentRouteDisplayed ? 'pi-comments' : 'pi-desktop'"
      />
      <span>{{ isCurrentRouteDisplayed ? $t("openChat") : $t("openApp") }}</span>
      <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center text-xs" />
    </AppButton>

    <AppButton
      v-tooltip.top="$t('wordsRecent')"
      icon="pi pi-history"
      :variant="v2ResponseStore.recentConversationsOpen ? undefined : 'secondary'"
      outlined
      @click="toggleConversationList()"
    />
    <AppButton
      v-tooltip.top="$t('startNewConversation')"
      class="pl-1.5 pr-1.5 pt-1.5 pb-1.5"
      :variant="isNew ? undefined : 'secondary'"
      outlined
      @click="startNewConversation()"
    >
      <NewChatIcon class="h-5 w-5" />
    </AppButton>
    <AppButton
      v-tooltip.top="'Return to normal app layout'"
      variant="secondary"
      outlined
      icon="pi pi-arrow-down-left-and-arrow-up-right-to-center"
      @click="switchFromV2ToWidget"
    />
  </div>
</template>

<script setup lang="ts">
import NewChatIcon from "../icons/NewChatIcon.vue";

const v2ResponseStore = useV2ResponseStore();
const { isCurrentRouteDisplayed, toggleCurrentRoute, switchFromV2ToWidget } =
  useV2Layout();

const isNew = computed(() => {
  if (
    (!!v2ResponseStore.messages?.length || !!v2ResponseStore.lastConversationId) &&
    !v2ResponseStore.recentConversationsOpen
  )
    return false;
  if (v2ResponseStore.recentConversationsOpen) return false;

  return true;
});

function startNewConversation() {
  v2ResponseStore.startNewConversation();
  v2ResponseStore.toggleRecentConversations(false);
}

function toggleConversationList() {
  v2ResponseStore.toggleRecentConversations();
  v2ResponseStore.isNewConversation = false;
}
</script>

<style scoped></style>
